__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/35925bc/packs/";